import React from "react";
import { Tooltip } from "antd";

export default function VerifiedBadge({ matricule, size = 18, style = {} }) {
  if (!matricule || String(matricule).trim() === "") return null;
  return (
    <Tooltip title="Compte vérifié">
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        style={{ marginLeft: 6, flex: "0 0 auto", verticalAlign: "middle", ...style }}
        aria-label="Compte vérifié"
      >
        <path
          style={{ fill: "#3897f0" }}
          d="M12 1.5l2.4 1.8 3-.3 1.2 2.7 2.7 1.2-.3 3L23 12l-1.8 2.4.3 3-2.7 1.2-1.2 2.7-3-.3L12 22.5l-2.4-1.8-3 .3-1.2-2.7-2.7-1.2.3-3L1 12l1.8-2.4-.3-3 2.7-1.2 1.2-2.7 3 .3L12 1.5z"
        />
        <path
          style={{ fill: "#fff" }}
          d="M10.6 15.4l-3-3 1.4-1.4 1.6 1.6 4.4-4.4 1.4 1.4-5.8 5.8z"
        />
      </svg>
    </Tooltip>
  );
}
